import { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import HeroSection from '../components/HeroSection';
import SocialProofBar from '../components/SocialProofBar';
import TrustGuarantees from '../components/TrustGuarantees';
import PetTypeHeroBanner from '../components/PetTypeHeroBanner';
import DeliveryInfoBox from '../components/DeliveryInfoBox';
import PricingSection from '../components/PricingSection';
import BenefitsSection from '../components/BenefitsSection';
import BoxOpeningSection from '../components/BoxOpeningSection';
import ClientsSection from '../components/ClientsSection';
import FAQSection from '../components/FAQSection';
import SubscribeFunnel from '../components/SubscribeFunnel';
import { useLanguage } from '../context/LanguageContext';

export default function LandingPage() {
  const [showFunnel, setShowFunnel] = useState(false);
  const { t } = useLanguage();

  const openFunnel = () => setShowFunnel(true);
  const closeFunnel = () => setShowFunnel(false);

  return (
    <div className="min-h-screen bg-brand-cream" data-testid="landing-page">
      <Navbar onSubscribeClick={openFunnel} />
      {/* Sticky March Promo Banner - orange fills from navbar to text */}
      <div className="fixed top-[80px] left-0 right-0 z-30 bg-brand-orange text-white text-center shadow-sm px-4 md:px-6" style={{paddingTop: '32px', paddingBottom: '10px'}}>
        <p className="text-xs md:text-base font-semibold leading-snug">
          {t('promo_banner')}
        </p>
        <p className="text-[10px] md:text-[11px] opacity-70 leading-tight mt-1">
          {t('promo_disclaimer')}
        </p>
      </div>
      <main>
        <HeroSection onSubscribeClick={openFunnel} />
        <SocialProofBar />
        <PetTypeHeroBanner />
        <TrustGuarantees />
        <ClientsSection />
        <PricingSection onSubscribeClick={openFunnel} />
        <DeliveryInfoBox />
        <BoxOpeningSection onSubscribeClick={openFunnel} />
        <BenefitsSection onSubscribeClick={openFunnel} />
        <FAQSection />
      </main>
      <Footer onSubscribeClick={openFunnel} />
      <ScrollToTop />
      <SubscribeFunnel isOpen={showFunnel} onClose={closeFunnel} />
    </div>
  );
}
